import React from 'react';
import styles from './styles';
import {Input} from 'antd';
import {FormattedMessage} from 'react-intl';

const getTextPasswordInput = (props: any) => {
  return (
    <Input.Password {...props} style={{...styles.inputDefault, ...props.style}}>
    </Input.Password>
  );
};

const getTextPasswordInputWithPlaceholder = (props: any) => {
  return (
    <FormattedMessage id={props.placeholder}>
      {(p: any) => <Input.Password {...props} placeholder={p} style={{...styles.inputDefault, ...props.style}}/>}
    </FormattedMessage>
  );
};

export const RBHTextPasswordInput = (props: any) => {
  return props.placeholder ? getTextPasswordInputWithPlaceholder(props) : getTextPasswordInput(props);
};

export default RBHTextPasswordInput;
